// extracted by css-extract-rspack-plugin
export default {"cls1":"LandingScreen-cls1_7n2","cls2":"LandingScreen-cls2_tBt LandingScreen-cls1_7n2"};